// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"303":"horizon","441":"start"}[chunkId] || chunkId) + "-legacy." + {"303":"05bc0ec1","381":"426f3d8b","441":"3df7122c"}[chunkId] + ".js";
};